var _g, _text, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Draft_Status",
    "data-name": "Draft Status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 23,
    viewBox: "0 0 62 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_6760",
    "data-name": "Path 6760",
    fill: "#ececec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 57.5 22.5 L 4.5 22.5 C 2.294389963150024 22.5 0.5 20.70561027526855 0.5 18.5 L 0.5 4.5 C 0.5 2.294389963150024 2.294389963150024 0.5 4.5 0.5 L 57.5 0.5 C 59.70560836791992 0.5 61.5 2.294389963150024 61.5 4.5 L 61.5 18.5 C 61.5 20.70561027526855 59.70560836791992 22.5 57.5 22.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.5 1 C 2.570091247558594 1 1 2.570089340209961 1 4.5 L 1 18.5 C 1 20.42991065979004 2.570091247558594 22 4.5 22 L 57.5 22 C 59.42990875244141 22 61 20.42991065979004 61 18.5 L 61 4.5 C 61 2.570089340209961 59.42990875244141 1 57.5 1 L 4.5 1 M 4.5 0 L 57.5 0 C 59.98527908325195 0 62 2.014720916748047 62 4.5 L 62 18.5 C 62 20.98527908325195 59.98527908325195 23 57.5 23 L 4.5 23 C 2.014720916748047 23 0 20.98527908325195 0 18.5 L 0 4.5 C 0 2.014720916748047 2.014720916748047 0 4.5 0 Z",
    stroke: "none",
    fill: "#1e325f"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Draft",
    transform: "translate(24 16)",
    fill: "#1e325f",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Draft"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2130",
    "data-name": "Group 2130",
    transform: "translate(-245 -188.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M258.313,206.225a6.1,6.1,0,1,1,6.1-6.1A6.1,6.1,0,0,1,258.313,206.225Zm0-11.392a5.3,5.3,0,1,0,5.3,5.3A5.3,5.3,0,0,0,258.313,194.833Z",
    fill: "#1e325f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M258.313,204.223a4.094,4.094,0,1,1,4.094-4.094A4.1,4.1,0,0,1,258.313,204.223Zm0-7.388a3.294,3.294,0,1,0,3.293,3.294A3.3,3.3,0,0,0,258.313,196.835Z",
    fill: "#1e325f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M258.313,202.466a2.337,2.337,0,1,1,2.337-2.337A2.34,2.34,0,0,1,258.313,202.466Zm0-3.875a1.537,1.537,0,1,0,1.537,1.538A1.54,1.54,0,0,0,258.313,198.591Z",
    fill: "#1e325f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.425ff22985cb34b03b6ad14c57829846.svg";
export { ForwardRef as ReactComponent };